import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { TableTooltip } from '../../../../../components/general/table';
import { Attachment } from '../../../../../../shared/types/shared';
import { PqrAttachmentProps } from './props';
import {
    PqrAttachmentActions,
    PqrAttachmentActionsLast,
} from '../../form/attachment/actions';
import { DateTooltip } from '../../../../../components/general/dateTooltip';

dayjs.extend(relativeTime);
dayjs.locale('es');

export const usePqrAttachment = ({ attachment }: PqrAttachmentProps) => {
    const columns: GridColDef<Attachment>[] = [
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <PqrAttachmentActions attachment={row.row} />,
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => <TableTooltip value={row.row.name || ''} />,
        },
        {
            field: 'createdBy',
            headerName: 'Creado por',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.createdBy
                            ? `(${row.row.createdBy.username}) ${row.row.createdBy.name} ${row.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <DateTooltip date={row.row.created_at} showFornow />
            ),
        },
        {
            field: 'link',
            headerName: 'Web link adjunto',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <PqrAttachmentActionsLast attachment={row.row} />
            ),
        },
    ];

    return {
        columns,
        rows: attachment,
    };
};
